import React from 'react'
import NativeButton, { ButtonProps } from '@mui/material/Button'
import { css } from 'aphrodite'
import Styles from 'components/ui/Styles'

interface IButtonProps extends ButtonProps {
  noArrow?: boolean,
}

const Button = ({
  classes,
  className,
  startIcon,
  endIcon,
  onMouseOut,
  onMouseOver,
  onClick,
  ref,
  variant,
  children,
  noArrow,
}: IButtonProps) => (
  <NativeButton
    variant={variant}
    classes={{
      ...classes,
      root: `${css(Styles.button)} ${classes?.root} ${noArrow ? '' : 'tw-inline primary-btn'}`,
    }}
    className={className}
    startIcon={startIcon}
    endIcon={endIcon}
    ref={ref}
    onClick={onClick}
    onMouseOver={onMouseOver}
    onMouseOut={onMouseOut}
  >
    {children}
  </NativeButton>
)
Button.defaultProps = {
  noArrow: false,
}
export default Button
